import { render, staticRenderFns } from "./heard.vue?vue&type=template&id=2be63380&scoped=true&"
import script from "./heard.vue?vue&type=script&lang=js&"
export * from "./heard.vue?vue&type=script&lang=js&"
import style0 from "./heard.vue?vue&type=style&index=0&id=2be63380&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2be63380",
  null
  
)

export default component.exports